'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { Reference } from '@eliadmin/core/src/api/references/references-types';
import { Container } from '@eliadmin/core/src/components/ui/container';
import { Dialog, DialogContent, DialogTrigger } from '@eliadmin/core/src/components/ui/dialog';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export const ReferenceGallery = ({ reference }: { reference: Reference }) => {
  return (
    <Container className={cn('', 'ea-reference-gallery__wrapper')}>
      {reference?.images?.map((image, index) => (
        <Dialog key={index}>
          <DialogTrigger className={cn('', 'ea-reference-gallery__trigger')}>
            <Image
              src={image.url}
              alt={resolveImageAlt(image, undefined)}
              className={cn('', 'ea-reference-gallery__image')}
              fill
              sizes="50vw"
            />
          </DialogTrigger>
          <DialogContent className={cn('', 'ea-reference-gallery__content')}>
            <div className="relative mx-auto h-[300px] w-full sm:h-[500px]">
              <Image
                src={image.url}
                alt={resolveImageAlt(image, undefined)}
                className="mx-auto rounded-[6px] object-cover"
                fill
                objectFit="cover"
              />
            </div>
          </DialogContent>
        </Dialog>
      ))}
    </Container>
  );
};
